import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { offerReducer, OfferState } from './offer.reducer';

export interface OfferHubState {
  offer: OfferState;
}

export const reducers: ActionReducerMap<OfferHubState> = {
  // @ts-ignore
  offer: offerReducer,
};

export const getOfferHubState = createFeatureSelector<OfferHubState>('offer');
